// extracted by mini-css-extract-plugin
export default {"wrapper":"back-button-module--wrapper--a5594","iconWrapper":"back-button-module--icon-wrapper--6b6c3","text":"back-button-module--text--766d8"};